import axios from "axios";

export default class GeoServer {
    //static API_URL = 'https://nluis.nlupc.go.tz/geoserver/nluis'
    static API_URL = 'https://nluis.nlupc.go.tz/geoserver/nluis'
    //static API_URL = 'https://nluis.nlupc.go.tz/geoserver'
    //static API_URL = 'http://0.0.0.0:8080/geoserver/nluis'
}